import { useIsMobile } from '../../hooks/useIsMobile';
import { VaultMobile } from './VaultMobile';
import { VaultDesktop } from './VaultDesktop';

/**
 * Password Vault. Computer e telefono sono due pagine con la stessa domanda
 * ("dov'è l'accesso di X?"): VaultDesktop (tessere coi loghi dei servizi,
 * ridisegnato il 26/10/2026) e VaultMobile (un portachiavi: si cerca e si copia).
 * La pagina del computer di prima (quattro numeri, tabella a sette colonne,
 * ordina e filtra) è copiata in os-planning/ridisegno/prima-del-ridisegno/lavoro.
 */
export function VaultPage() {
  const isMobile = useIsMobile();
  return isMobile ? <div className="page"><VaultMobile /></div> : <VaultDesktop />;
}
